module.exports = __webpack_public_path__ + "img/chongqing-bridge.13966dec.png";